import { Navigate, Outlet } from 'react-router-dom'
import paths from 'constants/paths'
import PropTypes from 'prop-types'
import React from 'react'
import { userRoleSelector } from 'domain/User/selectors'
import { useSelector } from 'react-redux'

const ProtectedRoute = ({ allowedRoles }) => {
  const userRole = useSelector(userRoleSelector)

  return allowedRoles.includes(userRole) ? (
    <Outlet />
  ) : (
    <Navigate replace to={paths.overview} />
  )
}

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ProtectedRoute
